export default __webpack_public_path__ + "static/media/gallery-wip-handle_01.a8d804fb.jpg";